export default class MenuMobile {
  constructor() {
    this.openMenuBtn = $('.sidenav-open');
    this.closeMenuBtn = $('.sidenav-close');
    if (this.openMenuBtn && this.closeMenuBtn) {
      this.initMenu();
    }
  }

  initMenu() {
    this.openMenuBtn.on('click', function() {
      $('.sidebar-left').addClass('active');
      $('.sidebar-left').addClass('fadeInLeft');
      $('.sidenav-close').addClass('open');
    });
    this.closeMenuBtn.on('click', function() {
      $('.sidebar-left').removeClass('active');
      $('.sidebar-left').removeClass('fadeInLeft');
      $('.sidenav-close').removeClass('open');
    });
  }
}
